import { render, staticRenderFns } from "./IconTextTag.vue?vue&type=template&id=981750bc&"
import script from "./IconTextTag.vue?vue&type=script&lang=js&"
export * from "./IconTextTag.vue?vue&type=script&lang=js&"
import style0 from "./IconTextTag.vue?vue&type=style&index=0&id=981750bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports